import en from './strings.en';

const ru = {
    title: 'Поиск активных перевозчиков'
};

export default { ru, en: { ...ru, ...en} };
